import { render, staticRenderFns } from "./ProgramsList.vue?vue&type=template&id=46ee870c&scoped=true&"
import script from "./ProgramsList.vue?vue&type=script&lang=js&"
export * from "./ProgramsList.vue?vue&type=script&lang=js&"
import style0 from "./ProgramsList.vue?vue&type=style&index=0&id=46ee870c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ee870c",
  null
  
)

export default component.exports